import createProperty from './create-property';

export default createProperty({
  default: '',
  validate(v) {
    return typeof v === 'string';
  },
});
